import axios from "axios";
import { useEffect, useState } from "react";

const PaymentSettings = () => {
  const [settings, setSettings] = useState({
    upi_id: "",
    account_number: "",
    bank_name: "",
    ifsc_code: "",
    account_holder_name: "",
    qr_img: "", // Stores the image path
  });

  const [qrFile, setQrFile] = useState(null); // Store uploaded file

  async function fetchSetting() {
    try {
      const token = localStorage.getItem("token"); // Retrieve token from localStorage

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/admin/getBankDetails`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add Authorization header
          },
        }
      );

      if (response?.data?.data) {
        setSettings(response.data.data); // Ensure correct data structure
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  }

  useEffect(() => {
    fetchSetting();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];

      const reader = new FileReader();
      reader.readAsDataURL(file); // Convert file to Base64
      reader.onloadend = () => {
        setSettings((prevSettings) => ({
          ...prevSettings,
          qr_img: reader.result, // Store Base64 preview in state
        }));
      };

      setQrFile(file); // Store the file separately for submission
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL_API}/admin/updateBankDetails`,
        {
          upi_id: settings.upi_id,
          account_number: settings.account_number,
          bank_name: settings.bank_name,
          ifsc_code: settings.ifsc_code,
          account_holder_name: settings.account_holder_name,
          qr_img: settings.qr_img, // Send Base64 string as JSON
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setSettings((prevSettings) => ({
        ...prevSettings,
        qr_img: response?.data.qr_img, // Update stored QR path if returned
      }));

      alert("Settings updated successfully!");
      fetchSetting(); // Refresh settings after update
    } catch (error) {
      console.error("Error updating settings:", error);
      alert("Failed to update settings.");
    }
  };

  return (
    <div className="ml-0 lg:ml-[256px] p-1 flex justify-center">
      <div className="bg-[#ffffff]  p-6 rounded-xl shadow-lg w-full max-w-4xl">
        <h2 className="text-3xl font-semibold mb-4 text-center">Settings</h2>

        {/* Payment Settings Section */}
        <div className="p-4 rounded-lg">
          <h4 className="text-lg font-semibold mb-6 border-b pb-2 text-black">
            Payment Settings
          </h4>
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Conditional Grid Layout */}
            <div
              className={`grid gap-6 items-center ${settings.qr_img
                  ? "grid-cols-1 md:grid-cols-3"
                  : "grid-cols-1 md:grid-cols-2"
                }`}
            >
              {/* Left Side Inputs */}
              <div className="space-y-4">
                <div>
                  <label className="block text-black">UPI ID</label>
                  <input
                    type="text"
                    name="upi_id"
                    value={settings.upi_id}
                    onChange={handleChange}
                    className="w-full p-2 rounded bg-white text-black border border-gray-600 focus:ring-2 focus:ring-green-500"
                  />
                </div>
                <div>
                  <label className="block text-black">Account Number</label>
                  <input
                    type="text"
                    name="account_number"
                    value={settings.account_number}
                    onChange={handleChange}
                    className="w-full p-2 rounded bg-white text-black border border-gray-600 focus:ring-2 focus:ring-green-500"
                  />
                </div>
                <div>
                  <label className="block text-black">Bank Name</label>
                  <input
                    type="text"
                    name="bank_name"
                    value={settings.bank_name}
                    onChange={handleChange}
                    className="w-full p-2 rounded bg-white text-black border border-gray-600 focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Center QR Code - Only Show If Available */}
              {/* Center QR Code - Show Chosen Image or Existing Image */}
              {settings.qr_img && (
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={
                      settings.qr_img.startsWith("data:image")
                        ? settings.qr_img // Show selected image preview
                        : `${process.env.REACT_APP_BASE_URL_API}/uploads/QrCodes/${settings.qr_img}`
                    } // Show stored image
                    alt="QR Code"
                    className="w-36 h-36 object-contain border p-2 border-gray-700 rounded-lg"
                  />
                </div>
              )}

              {/* Right Side Inputs */}
              <div className="space-y-4">
                <div>
                  <label className="block text-black">IFSC Code</label>
                  <input
                    type="text"
                    name="ifsc_code"
                    value={settings.ifsc_code}
                    onChange={handleChange}
                    className="w-full p-2 rounded bg-white text-black border border-gray-600 focus:ring-2 focus:ring-green-500"
                  />
                </div>
                <div>
                  <label className="block text-black">Acc Holder Name</label>
                  <input
                    type="text"
                    name="account_holder_name"
                    value={settings.account_holder_name}
                    onChange={handleChange}
                    className="w-full p-2 rounded bg-white text-black border border-gray-600 focus:ring-2 focus:ring-green-500"
                  />
                </div>
                <div>
                  <label className="block text-black">Upload QR Code</label>
                  <input
                    type="file"
                    className="block w-full p-2 text-sm text-black border border-black rounded-lg cursor-pointer bg-white focus:ring-2 focus:ring-green-500"
                    id="file_input"
                    name="qr_img"
                    onChange={handleFileChange}
                  />
                </div>
              </div>
            </div>

            {/* Save Button */}
            <button
              type="submit"
              className="bg-[#228BE6] hover:bg-black text-white py-2 px-4 rounded-lg w-full"
            >
              Save Settings
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PaymentSettings;
